import { Component, OnInit } from "@angular/core";
import { Message } from "../../Model/System/Message";
import { TestResult } from "../../Model/Dto/TestResult";
import { ModelService } from '../../Services/model.service';
import { TranslateService } from '@ngx-translate/core';
import { WawiSettings } from "../../Model/User/WawiSettings";
import { CustomField } from "../../Model/User/CustomField";
import { custom } from 'devextreme/ui/dialog';
import { InvoiceService } from "../../Services/invoice.service";
import { InvoiceStatistic } from "../../Model/OpenAi/InvoiceStatistic";
import { InvoiceSettingDto } from "../../Model/Dto/InvoiceSettingDto";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoginService } from "app/Services/login.service";
import { CustomerService } from "app/Services/customer.service";
import { SystemService } from "app/Services/system.service";



@Component({
    selector: "invoice",
    templateUrl: "invoice.component.html",
    standalone: false
})
export class InvoiceComponent {
  invoices: InvoiceStatistic[];
  invoiceSetting: InvoiceSettingDto = new InvoiceSettingDto();

  constructor(public systemService: SystemService, public translate: TranslateService, public invoiceService: InvoiceService, public loginService: LoginService, public customerService: CustomerService, public http: HttpClient) {
    this.update = this.update.bind(this);
    this.isAdmin = this.isAdmin.bind(this);
    this.export = this.export.bind(this);

    invoiceService.getAll(loginService.currentCustomer.id).subscribe((result: InvoiceStatistic[]) => {
      this.invoices = result;
      this.invoices.forEach(x => x.day = new Date(x.day));
    });
    invoiceService.GetInvoiceSetting(loginService.currentCustomer.id).subscribe((result: InvoiceSettingDto) => {
      this.invoiceSetting = result;
    });

  }

  public update() {
    this.invoiceService.updateInvoiceSetting(this.loginService.currentCustomer.id, this.invoiceSetting).subscribe((result: InvoiceSettingDto) => {
      this.invoiceSetting = result;
    });
  }

  public updateCustomer(){
    this.customerService.update(this.loginService.currentCustomer).subscribe();
  }

  public isAdmin() {
    return this.loginService.isAdmin;
  }

  public export() {
    this.invoiceService.ExportInvoices(this.loginService.currentCustomer.id).subscribe(result => {
      if (result != null && result != "")
        window.open(result, '_self', 'location=yes');
      else
        this.systemService.notifyInfo("Es gibt noch keine Rechnungen im Account");
    });
  }
}
